"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventEmitter = exports.EventEmitter = void 0;
const protocol_1 = require("./protocol");
class EventEmitter extends protocol_1.Protocol {
    emit(type, data, key) {
        const events = this.eventMap.get(type);
        if (!events) {
            return;
        }
        const callbacks = this.getCallbacks(type, key);
        callbacks.forEach(cb => {
            cb(data);
        });
    }
}
exports.EventEmitter = EventEmitter;
exports.eventEmitter = process.env.SSR ? null : new EventEmitter();
